import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../auth.service';
import { Reset } from './reset-password.model';
import { environment } from 'src/environments/environment';
import { isCheckinReturnUrl } from '../../self-checkin/self-checkin-flow.service';
import { TenantService } from 'src/app/tenant/tenant.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  token: string = '';
  email: string = '';
  resetForm: FormGroup = new FormGroup({});
  isLoading: boolean = true;
  resetComplete: boolean = false;
  tenantSubdomain: string = '';
  returnUrl = '';
  error: string = null;
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private tenantService: TenantService
  ) {} 

  async ngOnInit() {
    this.email = decodeURI(this.route.snapshot.params['email']);
    this.token = decodeURI(this.route.snapshot.params['token']);
    var tenantData = await this.tenantService.getSimpleTenant(); 
    this.tenantSubdomain = tenantData.subdomain;
    const destination = this.route.snapshot.queryParams['returnUrl'] || sessionStorage.getItem('CSCheckinReturn:' + this.tenantSubdomain);
    if (isCheckinReturnUrl(destination, this.tenantSubdomain)) this.returnUrl = destination;
    this.resetForm = new FormGroup(
      {
        password: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.pattern(
              '^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\\d]){1,})(?!.*\\s).{6,}$'
            ),
          ])
        ),
        //  '^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\\d]){1,})(?=(.*[\\W]){1,})(?!.*\\s).{7,}$'
        confirmPassword: new FormControl(null, [Validators.required]),  
      },
      { validators: this.authService.passwordMismatchValidator }
    );
    this.resetForm.reset();

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = "";
    });
  }      


  getDomain() {
    if (environment.production == false)
      return "church-services-staging";
    return "church-services";
  }  

  onSubmit() {  
    if (!this.resetForm.valid) {
      return;
    }

    const reset: Reset = {
      email: this.email,
      password: this.resetForm.get('password').value,
      token: this.token,
    };
    this.isLoading = true;
    this.authService.ResetPassword(reset).subscribe(
      (data) => {
        this.resetComplete = true;
        this.error = null;
        this.isLoading = false;
      },
      (errorMessage) => {
        this.error = errorMessage.message;
        this.resetComplete = false;
        this.isLoading = false;
      }
    );
    this.resetForm.reset();
  }
}
